
import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
    updateDoc,
    setDoc,
    runTransaction,
} from "firebase/firestore";

import { db } from "../apis/auth";


const collectionName = "poles";

// export async function getAllTickets(zone = 0, ward = 0, deviceType = -1, states = [0,1,2,3]) {

//     var queryObj = query(
//         collection(db(), 'tickets'));
//         if (zone !== 0){
//             queryObj = query(
//                 queryObj,
//                 where("zn", "==", zone));

//             if (ward !== 0){
//                 queryObj = query(
//                     queryObj,
//                     where("wd", "==", ward));
//             }
//         }
//         if (deviceType !== -1) {
//             queryObj = query(
//                 queryObj,
//                 where("dt", "==", deviceType));
//         }
//         queryObj = query(
//             queryObj,
//             where("st", "in", states));

//     var data = [];
//     // debugger;
//     await getDocs(queryObj).then((querySnapshot) => {

//         querySnapshot.forEach((doc) => {
//             console.log("ReportManager : GetDailyReport() users docs : ", JSON.stringify(doc.data()));
//             data.push(doc.data());
//         });

//     }).catch((error)=>{
//         console.log(`====> Error fetch : ${error}`);
//         return Promise.reject(error);
//     });
//     // debugger;
//     return Promise.resolve(data);
// }

// export async function createTicket(data) {
//     const collectionRef = collection(db(), "tickets");
//     await setDoc(doc(collectionRef, data.id), data).catch((e) => {
//         return Promise.error(e);
//     });
//     return Promise.resolve();

// }

export async function updatePoles(data) {
    // const collectionRef = collection(db(), "poles");

    try {
        await runTransaction(db(), async (transaction) => {
            for (var poleRef in data) {
                const sfDocRef = doc(db(), "poles", poleRef);
                transaction.update(sfDocRef, data[poleRef]);
            }
            // const sfDoc = await transaction.get(sfDocRef);
            // if (!sfDoc.exists()) {
            //     throw "Document does not exist!";
            // }
        });
        console.log("Transaction successfully committed!");
        return Promise.resolve(true);
    } catch (e) {
        console.log("Transaction failed: ", e);
        return Promise.error(e);
    }
}

export function getAllPole() {
    return new Promise((resolve, reject) => {
        // Start with the base query
        let queryObj = query(
            collection(db(), collectionName),
        );
        getDocs(queryObj)
            .then(querySnapshot => {
                const devices = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                resolve(devices);
            })
            .catch(error => {
                console.error(`Error fetching SLC devices: ${error}`);
                reject(error);
            });
    });
}
export async function getPoleBySlcId(slc_id) {

    var queryObj = query(
        collection(db(), "poles"),
        where("slc_id", "==", slc_id),
    );
    var result = [];
    await getDocs(queryObj).then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            result.push(doc.data());
        })


    }).catch((error) => {
        console.log(`====> Error fetch : ${error}`);
    });
    if (result != null) {
        return Promise.resolve(result);
    }
    return Promise.reject("docment not foun");
}




